/**
 * View is reserved for "pages" like FavoritesListView, so actually - for routes
 * We align this value with analytics team (algolytics, it's called view_type there),
 * because we use this value for analytics events
 *
 * this enum is also mapped to algolytics in `mapViewToAlgolytics`
 */
export enum View {
    UNKNOWN = -1,
    MY_OFFERS = 0,
    APPLICATION_SENT = 2,
    FAVORITE = 3,
    DISMISSED = 4,
    MY_OFFER = 5,
    THREAD = 6,
    /**
     * TODO: HOME_MATCH is actually not a page, but a section of a page.
     * However, is was implemented like that, that we pass it to analytics events (as view_type, so a page).
     * This will be handeled with - https://app.clickup.com/t/869ajh7bg
     */
    HOME_MATCH = 7,
    SETTINGS = 8,
    MESSAGES = 9,
    PREFERENCES = 10,
    COMPARATOR = 11,
    DASHBOARD = 12
}
/**
 * View is reserved for "pages" like FavoritesListView, so actually - for routes
 * We align this value with analytics team (algolytics, it's called view_type there),
 * because we use this value for analytics events
 *
 * this enum is also mapped to algolytics in `mapViewToAlgolytics`
 */
export enum View {
    UNKNOWN = -1,
    MY_OFFERS = 0,
    APPLICATION_SENT = 2,
    FAVORITE = 3,
    DISMISSED = 4,
    MY_OFFER = 5,
    THREAD = 6,
    /**
     * TODO: HOME_MATCH is actually not a page, but a section of a page.
     * However, is was implemented like that, that we pass it to analytics events (as view_type, so a page).
     * This will be handeled with - https://app.clickup.com/t/869ajh7bg
     */
    HOME_MATCH = 7,
    SETTINGS = 8,
    MESSAGES = 9,
    PREFERENCES = 10,
    COMPARATOR = 11,
    DASHBOARD = 12
}
